import { render, staticRenderFns } from "./StatsCardCustomizable.vue?vue&type=template&id=5a41f87a&"
import script from "./StatsCardCustomizable.vue?vue&type=script&lang=js&"
export * from "./StatsCardCustomizable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports